import { createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setDialogAction,
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { HttpStatusCodeEnum } from '@/enums'
import { PlayerCardActionTypes } from '../constants'
import { PLAYER_CARD } from './api.routes'

import { PlayerCardModels } from '../'
import { getRGExclusionThunk } from './get-rg-exclusion.thunk'

const apiService: RestApiService = Container.get(RestApiService)

export const addRGExclusionThunk = createAsyncThunk(
  PlayerCardActionTypes.ADD_RG_EXCLUSION,
  async (payload: PlayerCardModels.AddRGExclusionPayload, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoadingFullAction(true))

      const { auth } = thunkAPI.getState() as ApplicationState

      apiService.requestParams = {
        method: 'POST',
        endpoint: PLAYER_CARD.ADD_RG_EXCLUSION,
        body: {
          ...payload,
          brandId: auth.brand.siteId.toString(),
          //brandId: 'f1c808ad-dda5-4aa5-8553-63f99562ad05',
        },
        isIncentiveAPI: true,
      }

      const response: PlayerCardModels.AddRGExclusionResponse =
        await apiService.sendData(auth.brand.siteId.toString(), auth.token)

      thunkAPI.dispatch(setLoadingFullAction(false))

      let message = i18n.t('messages.successfully', {
        item: i18n.t(`playerCard.${payload.exclusionType}`).toLowerCase(),
        what: i18n.t('messages.added'),
      })

      if (
        response.statusCode &&
        response.statusCode !== HttpStatusCodeEnum.OK
      ) {
        message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')
      } else {
        thunkAPI.dispatch(setDialogAction({ open: false }))
        thunkAPI.dispatch(
          getRGExclusionThunk({
            exclusionType: payload.exclusionType,
            playerId: payload.playerId,
            limit: 25,
            page: 1,
          }),
        )
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant:
            response.statusCode && response.statusCode !== HttpStatusCodeEnum.OK
              ? 'error'
              : 'success',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
    }
  },
)
